import type { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuthMe } from '@/hooks/useAuth';

export function RequireAuth({ children }: { children: ReactNode }) {
  const location = useLocation();
  const { data, isLoading, isError } = useAuthMe();

  if (isLoading) {
    return (
      <div className="flex min-h-dvh items-center justify-center text-muted">
        <p className="animate-pulse-soft text-sm">Checking session…</p>
      </div>
    );
  }

  if (isError || !data?.user) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }

  return children;
}
